import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import useIndexDBValue from "src/app/hook/useIndexDBValue";
import { seachUserMetadata } from "src/app/modules/auth/core/_requests";
// import useViewportSize from "src/app/hook/useViewportSize";
import { SIGNATURE_MODULE, SIGNATURE_OBJECT_TYPE, SIGNATURE_TYPE } from "src/app/modules/component/button-in-phieu/constant";
import PrintButtonGroup from "src/app/modules/component/print-button-group";
import { SelectEditor, useSelectEditorManager } from "src/app/modules/component/select-editor";
import { TimeEditor } from "src/app/modules/component/time-editor/TimeEditor";
import { useTimeEditorManager } from "src/app/modules/component/time-editor/useTimeEditorManager";
import { IDanhSachDanhMuc } from "src/app/modules/phan-he-tiep-nhan-thanh-toan/models/TiepDonModel";
import { formatDateTime } from "src/app/modules/utils/FormatUtils";
import { hasAuthority, KEY_AUTHORITIES } from "src/app/modules/utils/Permission";
import { ConfirmDialog } from "../../../component/ConfirmDialog";
import DanhSachPhieu from "../../../component/DanhSachPhieu";
import LabelRequired from "../../../component/LabelRequired";
import ShowStatus from "../../../component/ShowStatus";
import { TableCollapseCustom } from "../../../component/table/table-collapse/TableCollapseCustom";
import ModalThucHienCDHA from "../../../phan-he-cdha-va-tdcn/components/modals/ModalThucHienCDHA";
import { CODE, KEY, KEY_DS_DANH_MUC_TIEP_DON, LIST_COLOR_TRANG_THAI_PHIEU, ORDER_TYPE_ID, RESPONSE_MESSAGE } from "../../../utils/Constant";
import WfButton from "../../../workflows/components/WfButton";
import { WfConstTracker, WfConstTrackerClinical } from "../../../workflows/Constant";
import { columnsDSCdhaTdcn } from "../../columns/tab-cdha-tdcn/ColumnTabCdhaTdcn";
import CheckIcon from "../../components/CheckIcon";
import DynamicComponentKB from "../../components/DynamicComponentKB";
import { WORKFLOW_ORDER_GROUP_STATUS_CODE } from "../../constants/ChiDinhDVConst";
import { PhanHeTiepDonContext } from "../../contexts/PhanHeTiepDonContext";
import { useIndicationInfo } from "../../hooks/useIndicationInfo";
import "../../PhanHeKhamBenh.scss";
import { deleteDSChiDinhDV, getDSDVDaChiDinh, getRisPacsIndicationInfo, getServiceListByType, updateOrderGroupFields } from "../../services/ChiDinhDVService";
import { getStatusDesc } from "../../services/KhamBenhService";
import { inPhieuChiDinhChung, inPhieuChiDinhCLS, inPhieuKetQuaCLS } from "../../services/PrintExportService";

export type KhamBenh = {
  thongTinKhamBenh?: any;
  setThongTinKhamBenh: ((data: any) => void) | undefined;
};

interface Iprops {
  danhSachPhieu?: boolean;
  generalInfo?: any
  onUpdate?: () => void;
}

export const TabCdhaTdcn = ({ danhSachPhieu = true, generalInfo = {}, onUpdate }: Iprops) => {
  const { benhNhanInfo, setBenhNhanInfo, statusChangedEventFunc } = useContext(PhanHeTiepDonContext);
  // const viewportSize = useViewportSize();

  const { visit, isConclusion, patient, orderId, encounter } = benhNhanInfo?.thongTinKhamBenh || generalInfo;
  const [dsXetNghiemDetail, setDsXetNghiemDetail] = useState<any[]>([]);
  const [dsPhieu, setDsPhieu] = useState<any[]>([]);
  const [selectedPhieu, setSelectedPhieu] = useState<any>(null);
  const [selectedIndex, setSelectedIndex] = useState<any>(0);
  const [dynamicData, setDynamicData] = useState<any>(null);
  const [resultData, setResultData] = useState<any>(null);
  const [shouldOpenResultModal, setShouldOpenResultModal] = useState<boolean>(false);
  const [statusDesc, setStatusDesc] = useState<any>([]);
  const [isUpdateWorkflow, setIsUpdateWorkflow] = useState(false);
  const [currentStatusWf, setCurrentStatusWf] = useState<string>();
  const [currentOrderId, setCurrentOrderId] = useState<string>(orderId);

  const { value: danhSachDanhMuc } = useIndexDBValue<IDanhSachDanhMuc>({
    key: KEY_DS_DANH_MUC_TIEP_DON,
  });

  const allowEdit = !isConclusion && hasAuthority(KEY_AUTHORITIES.UPDATE_FIELDS.PHIEU_CHI_DINH);

  // Sử dụng custom hook để load indication info
  const { loadIndicationInfo } = useIndicationInfo({
    getIndicationInfo: getRisPacsIndicationInfo
  });

  // Sử dụng custom hook để quản lý indication time
  const indicationTimeManager = useTimeEditorManager({
    name: "indicationTime",
    values: selectedPhieu,
    updateFields: updateOrderGroupFields,
    onUpdateSuccess: (updatedData) => {
      if (!updatedData?.indicationTime) return;
      // Cập nhật selectedPhieu với data mới
      setSelectedPhieu((prev: any) => ({
        ...prev,
        indicationTime: updatedData.indicationTime
      }));

      // Cập nhật trong danh sách phiếu
      setDsPhieu((prevList: any[]) =>
        prevList.map((phieu: any) =>
          phieu.id === selectedPhieu?.id
            ? { ...phieu, indicationTime: updatedData.indicationTime, date: moment(updatedData.indicationTime).format("DD/MM/YYYY") }
            : phieu
        )
      );
    }
  });

  const indicationPersonSelectManager = useSelectEditorManager({
    name: "indicationPerson",
    idFieldName: "id",
    values: selectedPhieu,
    updateFields: updateOrderGroupFields,
    buildPayload: (option) => ({
      indicationPerson: option?.fullName,
      indicationTime: selectedPhieu?.indicationTime
    }),
    onUpdateSuccess: (updatedData) => {
      if (!updatedData?.indicationPerson) return;
      // Cập nhật selectedPhieu với data mới
      setSelectedPhieu((prev: any) => ({
        ...prev,
        indicationPerson: updatedData.indicationPerson
      }));

      // Cập nhật trong danh sách phiếu
      setDsPhieu((prevList: any[]) =>
        prevList.map((phieu: any) =>
          phieu.id === selectedPhieu?.id
            ? { ...phieu, indicationPerson: updatedData.indicationPerson }
            : phieu
        )
      );
    },
    enableConfirmWithReason: false, // Không dùng confirm with reason cho trường hình thức
  });

  const requestDeptNameSelectManager = useSelectEditorManager({
    name: "requestDeptName",
    idFieldName: "id",
    values: selectedPhieu,
    updateFields: updateOrderGroupFields,
    buildPayload: (option) => ({
      requestDeptCode: option?.code,
      requestDeptName: option?.name,
      indicationTime: selectedPhieu?.indicationTime
    }),
    onUpdateSuccess: (updatedData) => {
      if (!updatedData?.requestDeptName) return;
      // Cập nhật selectedPhieu với data mới
      setSelectedPhieu((prev: any) => ({
        ...prev,
        requestDeptName: updatedData.requestDeptName
      }));

      // Cập nhật trong danh sách phiếu
      setDsPhieu((prevList: any[]) =>
        prevList.map((phieu: any) =>
          phieu.id === selectedPhieu?.id
            ? { ...phieu, requestDeptName: updatedData.requestDeptName }
            : phieu
        )
      );
    },
    enableConfirmWithReason: false,
  });

  const handleGetStatusDesc = async () => {
    try {
      let { data } = await getStatusDesc(WfConstTracker.RISPACS_ORDER);
      if (data?.code === CODE.SUCCESS) {
        setStatusDesc(data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    handleGetStatusDesc();
  }, []);

  const handleUpdate = () => {
    if (onUpdate) {
      onUpdate();
    } else {
      setBenhNhanInfo({
        ...benhNhanInfo,
        shouldUpdate: !benhNhanInfo?.shouldUpdate,
      });
      statusChangedEventFunc?.();
    }
  };

  const actionChanged = (code?: string) => {
    setCurrentStatusWf(code);
    handleSelectPhieu(selectedPhieu);
    handleUpdate();
    setIsUpdateWorkflow(!isUpdateWorkflow);
    toast.success(RESPONSE_MESSAGE.SUCCESS);
  };

  const handleReset = () => {
    setDsPhieu([]);
    setSelectedPhieu(null);
    setDsXetNghiemDetail([]);
  };

  const handleSelectPhieu = async (dataPhieu: any) => {
    try {
      if (!dataPhieu) {
        handleReset();
        return;
      };
      setSelectedIndex(dataPhieu?.index);

      // Gọi song song 2 API: lấy danh sách dịch vụ và thông tin chỉ định
      const [dvResponse, indicationInfo] = await Promise.all([
        getDSDVDaChiDinh({
          orderGroupId: dataPhieu?.id,
          type: ORDER_TYPE_ID.XET_NGHIEM
        }),
        loadIndicationInfo(dataPhieu?.id) //  Sử dụng hook
      ]);

      // Merge data với indication info từ RisPacsGroup
      // QUAN TRỌNG: Giữ nguyên orderGroupId (dataPhieu.id), không để bị đè bởi RisPacsGroup.id
      const updatedPhieu = {
        ...dataPhieu,
        ...(indicationInfo || {}), // Chỉ merge khi có data
        id: dataPhieu.id, // Luôn giữ orderGroupId
        risPacsGroupId: indicationInfo?.id // Lưu RisPacsGroupId riêng nếu cần
      };
      setSelectedPhieu(updatedPhieu);

      // Xử lý danh sách dịch vụ
      if (dvResponse?.data?.code === CODE.SUCCESS) {
        const newData = dvResponse.data.data?.map((item: any) => {
          return {
            ...item,
            terms: item?.terms?.map((term: any) => {
              if (term?.subs) {
                return {
                  ...term,
                  name: <CheckIcon data={term} color={term?.statusColor} className="ml-2" />,
                  subs: term?.subs?.map((sub: any) => {
                    return {
                      ...sub,
                      name: <CheckIcon color={term?.statusColor} data={sub} />
                    }
                  })
                }
              } else {
                return {
                  ...term,
                  name: <CheckIcon color={term?.statusColor} data={term} />
                }
              }
            })
          }
        });
        setDsXetNghiemDetail(newData || []);
      } else {
        setDsXetNghiemDetail([]);
      }
    } catch (error) {
      console.error(error);
      setDsXetNghiemDetail([]);
      toast.error(RESPONSE_MESSAGE.ERROR);
    }
  }

  const handleConfirmDelete = async () => {
    try {
      await deleteDSChiDinhDV(selectedPhieu?.id);
      handleUpdate();
      setSelectedIndex(0);
    } catch (error) {
      console.error(error);
      toast.error("Xảy ra lỗi, vui lòng thử lại!");
    }
  }

  const updataData = async () => {
    try {
      let { data } = await getServiceListByType({
        visitId: visit?.id,
        type: ORDER_TYPE_ID.CDHA
      });
      if (CODE.SUCCESS === data?.code) {
        let dsPhieuConverted = data?.data?.map((item: any, index: number) => {
          return {
            ...item,
            index,
            date: moment(item?.indicationTime).format("DD/MM/YYYY"),
          };
        });
        let currentIndex = orderId !== currentOrderId ? 0 : selectedIndex;
        setDsPhieu(dsPhieuConverted || []);
        handleSelectPhieu(dsPhieuConverted?.[currentIndex] || dsPhieuConverted?.[0]);
      } else {
        handleReset();
      }
    } catch (error) {
      console.error(error);
      handleReset();
    }
  };
  
  const handleClickWfButton = (data: any) => {
    setDynamicData({
      ...data,
      generalInfo,
      orderGroupId: selectedPhieu?.id,
      callbackFunc: () => {
        setSelectedIndex(0);
      },
      updateWorkflow: () => {
        setIsUpdateWorkflow(!isUpdateWorkflow);
      }
    });
  };

  useEffect(() => {
    setCurrentOrderId(orderId);
  }, [orderId]);

  useEffect(() => {
    if (orderId) {
      updataData();
    }
  }, [benhNhanInfo?.shouldUpdate, generalInfo?.updateTab, orderId]);

  useEffect(() => {
    selectedPhieu && setCurrentStatusWf(selectedPhieu?.currStatusCode);
  }, [selectedPhieu]);

  const handleViewResult = (data: any) => {
    let isResultReleased = data?.isResultReleased || (data?.terms ? data?.terms[0]?.isResultReleased : null)
    let resultData = data?.obs?.attributeValue || (data?.terms ? data?.terms[0]?.obs?.attributeValue : null)
    if(isResultReleased) {
      setShouldOpenResultModal(true);
      setResultData(resultData);
    } else {
      toast.warning("Chưa trả kết quả");
    }
  };

  //  Các methods đã được thay thế bởi indicationTimeManager hook

  return (
		<Row className="h-100">
			<div>
				<div className="pt-4 bg-white">
					<Row className="mx-0">
						<Col xs={4} className="d-flex align-items-center mb-3">
							<LabelRequired label="Mã phiếu" className="min-w-100px" />
							<span className="fw-light text-truncate">
								{selectedPhieu?.code || '...'}
							</span>{' '}
						</Col>
						{/*  Sử dụng shared component */}
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Ngày y lệnh" className="min-w-100px" />
              <TimeEditor
                name="indicationTime"
                values={selectedPhieu}
                isEditingTime={indicationTimeManager.isEditingTime}
                editedTime={indicationTimeManager.editedTime}
                showValidationConfirm={indicationTimeManager.showValidationConfirm}
                validationMessage={indicationTimeManager.validationMessage}
                onEdit={indicationTimeManager.handleEditTime}
                onCancel={indicationTimeManager.handleCancelEdit}
                onSave={indicationTimeManager.handleSaveTime}
                onConfirmValidation={indicationTimeManager.handleConfirmValidation}
                onCancelValidation={indicationTimeManager.handleCancelValidation}
                onTimeChange={indicationTimeManager.setEditedTime}
                allowEdit={allowEdit}
              />
            </Col>
						<Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
							<LabelRequired label="Người chỉ định" className="min-w-100px" />
							<SelectEditor
                name="indicationPerson"
                values={{
                  indicationPerson: selectedPhieu?.indicationPerson
                }}
                options={[]}
                searchFunction={seachUserMetadata}
                searchObject={{ position: 1 }}
                urlData="data.content"
                getOptionLabel={(opt) => opt?.fullName || ""}
                inline={true}
                menuPlacement="top"
                isEditingSelect={indicationPersonSelectManager.isEditingSelect}
                editedValue={indicationPersonSelectManager.editedValue}
                showValidationConfirm={indicationPersonSelectManager.showValidationConfirm}
                showConfirmWithReason={indicationPersonSelectManager.showConfirmWithReason}
                validationMessage={indicationPersonSelectManager.validationMessage}
                onEdit={indicationPersonSelectManager.handleEditSelect}
                onCancel={indicationPersonSelectManager.handleCancelEdit}
                onSave={indicationPersonSelectManager.handleSaveSelect}
                onConfirmValidation={indicationPersonSelectManager.handleConfirmValidation}
                onCancelValidation={indicationPersonSelectManager.handleCancelValidation}
                onConfirmWithReason={indicationPersonSelectManager.handleConfirmWithReason}
                onCancelWithReason={indicationPersonSelectManager.handleCancelWithReason}
                onValueChange={indicationPersonSelectManager.setEditedValue}
                allowEdit={allowEdit}
              />
						</Col>
						<Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
							<LabelRequired label="Nơi chỉ định" className="min-w-100px" />
              <SelectEditor
                name="requestDeptName"
                values={{
                  requestDeptName: selectedPhieu?.requestDeptName
                }}
                options={danhSachDanhMuc?.listPhongKham || []}
                inline={true}
                menuPlacement="top"
                isEditingSelect={requestDeptNameSelectManager.isEditingSelect}
                editedValue={requestDeptNameSelectManager.editedValue}
                showValidationConfirm={requestDeptNameSelectManager.showValidationConfirm}
                showConfirmWithReason={requestDeptNameSelectManager.showConfirmWithReason}
                validationMessage={requestDeptNameSelectManager.validationMessage}
                onEdit={requestDeptNameSelectManager.handleEditSelect}
                onCancel={requestDeptNameSelectManager.handleCancelEdit}
                onSave={requestDeptNameSelectManager.handleSaveSelect}
                onConfirmValidation={requestDeptNameSelectManager.handleConfirmValidation}
                onCancelValidation={requestDeptNameSelectManager.handleCancelValidation}
                onConfirmWithReason={requestDeptNameSelectManager.handleConfirmWithReason}
                onCancelWithReason={requestDeptNameSelectManager.handleCancelWithReason}
                onValueChange={requestDeptNameSelectManager.setEditedValue}
                allowEdit={allowEdit}
              />
						</Col>
						<Col xs={8} className="d-flex align-items-center text-lable-input mb-3">
							<LabelRequired label="Chẩn đoán" className="min-w-100px" />
							<span className="fw-light text-truncate">
								{selectedPhieu?.provisionalDiagnosisName || '...'}
							</span>
						</Col>
					</Row>
				</div>
				<div className="bg-white spaces pt-2 mb-6">
					<DanhSachPhieu
						className="mb-2"
						handleSelectRowData={handleSelectPhieu}
						dsPhieu={dsPhieu as []}
						listColorPhieu={LIST_COLOR_TRANG_THAI_PHIEU}
						selectedIndex={selectedIndex}
					/>
					<TableCollapseCustom
						columns={columnsDSCdhaTdcn}
						data={dsXetNghiemDetail || []}
						childrenField="subs"
						className={`overflow-auto spaces h-calc-vh-${
							generalInfo?.isKhamDoan ? '400' : '510'
						}`}
						handleDoubleClick={handleViewResult}
					/>
				</div>
				<div className="d-flex justify-content-between align-items-center p-2 gap-3 bg-white">
					<div className="d-flex gap-2">
						{visit?.id &&
							patient?.id &&
							selectedPhieu?.id &&
							WORKFLOW_ORDER_GROUP_STATUS_CODE.HUY_GUI_PHIEU !== currentStatusWf && (
								<>
									<PrintButtonGroup
										grouped={false}
										config={[
											{
												label: 'Phiếu chỉ định chung',
												fetchExport: inPhieuChiDinhChung,
												params: {
													visitId: visit?.id,
													patientId: patient?.id,
													orderGroupId: selectedPhieu?.id,
												},
											},
											{
												label: 'Phiếu chỉ định theo phòng',
												fetchExport: inPhieuChiDinhChung,
												params: {
													visitId: visit?.id,
													patientId: patient?.id,
													orderGroupId: selectedPhieu?.id,
													isSplit: true,
												},
											},
											{
												label: 'Phiếu chỉ định (F2)',
												keyBtn: KEY.F2,
												fetchExport: inPhieuChiDinhCLS,
												params: {
													visitId: visit?.id,
													patientId: patient?.id,
													orderGroupId: selectedPhieu?.id,
													orderTypeId: ORDER_TYPE_ID.CDHA,
												},
											},
											{
												label: 'Phiếu kết quả (F3)',
												keyBtn: KEY.F3,
												signatureParams: {
													id: selectedPhieu?.id ?? '',
													objectType: SIGNATURE_OBJECT_TYPE.ORDER,
													module: SIGNATURE_MODULE.CLINICAL,
													type: SIGNATURE_TYPE.PHIEU_KQ_CDHA,
													encounterIdExec: encounter?.id,
												},
												fetchExport: inPhieuKetQuaCLS,
												params: {
													orderGroupId: selectedPhieu?.id,
													type: ORDER_TYPE_ID.CDHA,
												},
											},
										]}
									/>
								</>
							)}
						{selectedPhieu?.isAllowModify && !isConclusion && (
							<WfButton
								tracker={WfConstTrackerClinical.ORDER_GROUP}
								objectId={selectedPhieu?.id}
								additionalFunc={actionChanged}
								handleClick={handleClickWfButton}
								forceRender={isUpdateWorkflow}
							/>
						)}
					</div>
					<ShowStatus className="status-summary" statuses={statusDesc} />
				</div>
			</div>
			{dynamicData && (
				<DynamicComponentKB
					data={dynamicData}
					setData={setDynamicData}
					onConfirm={handleConfirmDelete}
					generalInfo={generalInfo}
					onUpdate={handleUpdate}
				/>
			)}
			{shouldOpenResultModal && (
				<ModalThucHienCDHA
					handleSubmitForm={() => {}}
					handleClose={() => setShouldOpenResultModal(false)}
					handleTraKetQua={() => {}}
					infoBenhNhan={benhNhanInfo?.thongTinKhamBenh || generalInfo}
					resultData={resultData}
					isViewModal
				/>
			)}
			{indicationTimeManager.showValidationConfirm && (
				<ConfirmDialog
					show={indicationTimeManager.showValidationConfirm}
					title="Xác nhận"
					message={indicationTimeManager.validationMessage}
					yes="Tiếp tục"
					cancel="Hủy"
					onYesClick={indicationTimeManager.handleConfirmValidation}
					onCancelClick={indicationTimeManager.handleCancelValidation}
					onCloseClick={indicationTimeManager.handleCancelValidation}
				/>
			)}
		</Row>
  );
};

export default TabCdhaTdcn;
